import { Component, HostListener, Injector, OnInit, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner, MatProgressSpinnerModule, ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { BasePage } from '../../services/base-page';

@Component({
  standalone: true,
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, MatFormField, ReactiveFormsModule, MatToolbar, MatIcon, MatListModule, MatDividerModule, MatProgressSpinnerModule, MatProgressSpinner, MatFormField, MatLabel, MatInput, MatButtonModule]
})
export class RegisterComponent extends BasePage implements OnInit {
  public form!: FormGroup;
  public userId: string = '';
  public isSignUpLoading = false;
  public showSignUpForm = true;
  public showPass: boolean = false;
  spinnerMode: ProgressSpinnerMode = 'determinate';
  spinnerValue = 50;
  constructor() {
    const injector = inject(Injector);

    //super();
    super(injector);
  }
  @HostListener('window:popstate')
  onPopState() {
  }


  ngOnInit() {

  }
  registUser(e: Event) {
    console.log('userId:', this.userId);
  }
  setupSignUpForm() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      username: new FormControl('', Validators.required),
      email: new FormControl(''),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    });
    this.form.setValue({ name: 'test' });
    this.form.value.name = 'test';
  }
  async onSignUp() {

    try {

      if (this.form.invalid) {
        const message = '輸入錯誤!';//await this.getTrans('INVALID_FORM');
        return this.showToast(message);
      }

      const formData = Object.assign({}, this.form.value);

      formData.name = formData.name.trim();
      formData.username = formData.username.trim();
      formData.email = formData.email.trim();
      formData.password = formData.password.trim();

      if (formData.email === '') {
        delete formData.email;
      }

      await this.showLoadingView({ showOverlay: false });
      this.isSignUpLoading = true;

      this.showContentView();
      this.isSignUpLoading = false;

      this.showToast('已登入');
      this.onDismiss();


    } catch (err: any) {

      this.showContentView();
      this.isSignUpLoading = false;

      if (err.code === 202) {
        //this.translate.get('USERNAME_TAKEN')
        //  .subscribe(str => this.showToast(str));
        this.showToast('姓名已經註冊過');  // "Username has already been registered",
      } else if (err.code === 203) {
        //this.translate.get('EMAIL_TAKEN')
        //  .subscribe(str => this.showToast(str));
        this.showToast('email已經註冊過'); // Email has already been taken",
      } else if (err.code === 125) {
        //this.translate.get('EMAIL_INVALID')
        //  .subscribe(str => this.showToast(str));
        this.showToast('EMAIL格式錯誤!');
      } else {
        //this.translate.get('ERROR_NETWORK')
        //  .subscribe(str => this.showToast(str));
        this.showToast('網路錯誤!');
      }
    }
  }
  onDismiss() {
    //this.modalCtrl.closeAll(); //dismiss();
  }
  onLoginButtonTouched() {
    //this.showLoginForm = true;
    //this.showSignUpForm = false;
    //this.setupLoginForm();
    //this.modalCtrl.closeAll(); //dismiss();
  }


}
